import type {
  BoltConfiguration,
  BoltConfigurationFormFieldKey,
} from '../../types';

export function summarizeProfileBoltConfigurationForDebug(
  bolt: BoltConfiguration
): Record<BoltConfigurationFormFieldKey, string> {
  return {
    boltModelingChoice: bolt.boltModelingChoice.value,
    boltBaseFamilyValue: bolt.boltBaseFamilyValue.value,
    boltSetActiveValue: bolt.boltSetActiveValue.value,
    boltDiaValue: bolt.boltDiaValue.value,
    boltQuantityValue: bolt.boltQuantityValue.value,
    boltLengthValue: bolt.boltLengthValue.value,
    boltItemDescriptionValue: bolt.boltItemDescriptionValue.value,
    boltMaterialValue: bolt.boltMaterialValue.value,
    boltStandardValue: bolt.boltStandardValue.value,
  };
}
